import { UserPlus } from '@sweep-io/sweep-design/dist/icons';
import { iconNameToIconComponent } from '../../pages/get-started/agenticPrompts';
import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

type IconSize = 'small' | 'medium' | 'large';

export const PromptLibraryIcon = ({ 
  icon, 
  color, 
  size = 'medium' 
}: { 
  icon?: string; 
  color?: string; 
  size?: IconSize;
}) => {
  const IconComponent =
    icon && iconNameToIconComponent[icon] ? iconNameToIconComponent[icon] : UserPlus;

  return (
    <Stack>
      <IconComponent color={color ?? colors.grey[700]} size={size} />
    </Stack>
  );
};
